import React from "react";
import { useSelector } from "react-redux";
import IndexBase from "../../Components/IndexApp";
// import CompleteProfileIndex from "../../Screens/Teacher/CompleteProfile/Index";
import { AppBarProps } from "../../Objects/interfaces/NavBarInterface";
import CompletProfilStep from "../../App/Profil/CompletProfilStep";
// import { NavbarProps } from "../../Objects/interfaces/NavBarInterface";

const CompleteProfilPage = () => {
  const teachr = useSelector((state: any) => state.user?.currentUser?.teachr);
  const navBar: AppBarProps = {
    index: 0
  }
  return (
    <IndexBase
      navBar={navBar}
      component={<CompletProfilStep teachr={teachr} />}
      teachr={teachr}
    />
  );
};

export default CompleteProfilPage;
